import { compose } from 'ramda'
import { withNamespaces } from '>/i18n'

import withLayout from '~/hoc/withLayout'

import Footer from '~/components/Footer/FooterGql'
import MobileAppSection from '~/components/landing-common/MobileAppSection'

const BecomePartner = ({ t }) => {
  return (
    <>
      <div className='become-partner'>
        <h2 className='become-partner__heading'>
          {t('heading')}
        </h2>
        <MobileAppSection
          title={t('title')}
          description={t('description')}
        />
      </div>
      <Footer />
    </>
  )
}

export default compose(
  withLayout({
    contentClassName: 'layout__content--with-footer',
    namespaces: ['become-partner'],
  }),
  withNamespaces(['become-partner'])
)(BecomePartner)
